import { render, staticRenderFns } from "./CustomerServiceIcon.vue?vue&type=template&id=465d0f4c&"
import script from "./CustomerServiceIcon.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports